import React from 'react';
import ReactDOM from 'react-dom';
import classNames from 'classnames';
import style from './index.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";

function getModal() {
  const existing = document.getElementById('search-modal');

  if (existing !== null) {
    return existing;
  }

  const modal = document.createElement('div');
  modal.id = 'search-modal';
  document.body.appendChild(modal);
  return modal;
}

export const SearchContainer = ({
  displayMode,
  children,
  onClickClose
}) => {
  const styles = [style.Search, style.wevoTheme];

  if (displayMode !== 'embedded') {
    styles.push(style.modal);
  }

  const searchClassName = classNames(...styles);

  const handleClickOutside = e => {
    const id = e.target.id;

    if (displayMode === 'visibleModal' && id === 'universal-search-modal') {
      // Search overlay had been clicked
      onClickClose === null || onClickClose === void 0 ? void 0 : onClickClose();
    }
  };

  if (true && displayMode === 'visibleModal') {
    return /*#__PURE__*/ReactDOM.createPortal( /*#__PURE__*/_jsx("div", {
      className: searchClassName,
      id: "universal-search-modal",
      onClick: handleClickOutside,
      children: children
    }), getModal());
  } else if (displayMode === 'embedded') {
    return /*#__PURE__*/_jsx("div", {
      className: searchClassName,
      children: children
    });
  } else {
    return null;
  }
};
export default SearchContainer;